
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TableStatus extends Vue {
  @Prop([Boolean, String]) readonly status!: boolean | string;
}
